import React from 'react';
import Breadcrumb from '../common/Breadcrumb';

const ClassRoom = () => {
  // Array of images for easier management
  const images = [    
    {
      src: '/images/gallery/library-1.png',
      alt: 'Modern classroom with technology',
    },
    {
      src: '/images/gallery/library-2.png',
      alt: 'Students collaborating in classroom',
    },
    {
      src: '/images/gallery/robotics-4.png',
      alt: 'Interactive learning session',
    },
    {
      src: '/images/gallery/lab-1.png',
      alt: 'Digital classroom setup',
    }
  ];

  return (
    <>
      <Breadcrumb
        pageTitle="Class Room"
        breadcrumbItems={[
          { label: 'Home', link: '/' },
          { label: 'Class Room' },
        ]}
        backgroundImage="images/banner/slide-2.png"
      />
      <section className="space-ptb">
         <div class="container">
          <div className="row align-items-center">
            <div className="col-md-12">
              <div className="section-title mb-4">
                <h2 className="title">
                  <span className="text-primary">Class Room</span>
                </h2>
              </div>
            </div>
          </div>       
     
          <div className='smart-classroom'>
          <div className="image-gallery">
            {images.map((image, index) => (
              <div className="image-item" key={index}>
                <img src={image.src} alt={image.alt} />
              </div>
            ))}
          </div>
          <div className="description">
            <p className="description-text">
              The lecture theatres are the epicenter of learning in any college or institute, we have paid special attention on our lecture theatres as they play an instrumental in the process of learning.
            </p>
            <p className="description-text">
              The lecture theatres are well designed, air conditioned, LCD projector supporting and ecologically built to suit the modern requirements of professional education.
            </p>
            <p className="description-text">
              The teacher uses a variety of teaching methods to cater to each learning style in the classroom. The methods vary from rhythmic or musical, as the students learn their multiplication facts by using rap, to a linguistic approach where the students are asked to memorize concepts in science. The lessons taught in the classroom are based off of the Standards of Learning in Lucknow for the Third grade, however they are taught in a variety of ways.
            </p>
          </div>      
          </div> 
          </div>
      </section>

      <style jsx>{`       
        .smart-classroom {
          padding: 20px 20px;
          background: #f8f8f8;
          margin-bottom:40px;
          border-radius:5px;
        }

        .image-gallery {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 20px;
          margin-bottom: 30px;          
        }

        .image-item img {
          width: 100%;
          height: 200px;
          object-fit: cover;
          border-radius: 8px;
          border: 1px solid #e2e8f0;
          transition: transform 0.3s ease;
        }

        .image-item img:hover {
          transform: scale(1.05);
        }


        .description-text {
          font-size: 1rem;
          line-height: 1.6;
          color: #4a5568;
          margin-bottom: 15px;
          text-align: justify;
        }

        .description-text:last-child {
          margin-bottom: 0;
        }

        @media (max-width: 768px) {          

          .image-gallery {
            grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
            gap: 15px;
          }

          .image-item img {
            height: 150px;
          }

          .description-text {
            font-size: 0.95rem;
            text-align: left;
          }
        }

        @media (max-width: 480px) {    
          .image-gallery {
            grid-template-columns: 1fr;
          }

          .image-item img {
            height: 120px;
          }
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .smart-classroom {
          animation: fadeIn 0.5s ease-out;
        }

        .image-item img:focus {
          outline: 2px solid #2c5282;
          outline-offset: 2px;
        }
      `}</style>
    </>
  );
};

export default ClassRoom;